import { LoadSpinner } from '@calizahq/react-components-v2'
import { usePotentialBookingFiltersContext } from '@sales-app/context/potentialBookingFilters/potentialBookingFilters'
import { AgentQueries } from '@sales-app/graphql/queries/agent.queries'
import { useDebounce } from '@shared/hooks'
import React, { ChangeEvent, useState } from 'react'

import { Dropdown } from '@/components'
import { FilterOptionsStyled } from '@/components/ListFilter/FilterOptionsStyled'
import { useGraphql } from '@/hooks/useGraphql'

export const AgentFilter = () => {
  const { agentId, setFilters } = usePotentialBookingFiltersContext()

  const [dropdownExpanded, setDropdownExpanded] = useState(false)
  const [searchString, setSearchString] = useState<string>()
  const debouncedSearch = useDebounce(searchString, 1000)
  const { data, isLoading } = useGraphql<AgentQueries.GET_SEARCH_AGENT.Response>(
    AgentQueries.getSearchAgent.name,
    AgentQueries.getSearchAgent(),
    {
      searchString: debouncedSearch,
    },
  )

  const handleCancel = () => {
    setDropdownExpanded(false)
  }

  const changeFilter = (val: number | string | null = null) => {
    setDropdownExpanded(false)
    if (typeof val === 'number') {
      setFilters({ agentId: val, unassigned: null })
    } else if (typeof val === 'string') {
      setFilters({ unassigned: true, agentId: null })
    } else {
      setFilters({ agentId: null, unassigned: null })
    }
  }

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    setSearchString(e.target.value)
  }

  const headerTitle = agentId ? data?.agents?.find((agent) => agent.id === agentId)?.name : 'Agent'

  return (
    <Dropdown
      className="hidden w-full md:w-auto lg:flex"
      expanded={dropdownExpanded}
      headerTitle={headerTitle || 'Agent'}
      onHideDropdown={handleCancel}
      renderHeader={() => <div></div>}
      selected={!!agentId}
      setExpanded={setDropdownExpanded}
    >
      <FilterOptionsStyled>
        <div className="flex w-full px-4">
          <input
            autoComplete="off"
            className="mb-2  w-full rounded border-2 border-border-secondary p-2 focus:outline-none"
            onChange={handleSearch}
            placeholder="Search"
            value={searchString || ''}
          />
        </div>
        <div className="flex w-full">
          {isLoading ? (
            <div className="flex h-24 w-full items-center justify-center">
              <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
            </div>
          ) : (
            <div className="flex max-h-48 min-h-24 w-full overflow-scroll">
              {data && data?.agents?.length && (
                <ul>
                  <li className={`${!agentId ? 'selected' : ''}`} onClick={() => changeFilter()} role={'presentation'}>
                    All
                  </li>
                  <li
                    className={`${!agentId ? 'selected' : ''}`}
                    onClick={() => changeFilter('unassigned')}
                    role={'presentation'}
                  >
                    Unassigned
                  </li>
                  {data?.agents.map((user) => (
                    <li
                      className={`${user.id === agentId ? 'selected' : ''}`}
                      key={user.id}
                      onClick={() => changeFilter(user.id)}
                      role={'presentation'}
                    >
                      {user.name || ''}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </div>
      </FilterOptionsStyled>
    </Dropdown>
  )
}
